import type { PublicationInboxSummary } from '@/hooks/usePublicationInbox';

import {
  publicationInboxFolderMeta,
  type PublicationInboxFolder,
} from '@/lib/publicationInboxPresentation';

type Props = {
  activeFolder: PublicationInboxFolder;
  summary: PublicationInboxSummary;
  onChange: (
    folder: PublicationInboxFolder
  ) => void;
};

const countForFolder = (
  folder: PublicationInboxFolder,
  summary: PublicationInboxSummary
) => {
  switch (folder) {
    case 'today':
      return summary.today;
    case 'new':
      return summary.new;
    case 'review':
      return summary.review;
    case 'action':
      return summary.action;
    case 'deadlines':
      return summary.deadlines;
    case 'hearings':
      return summary.hearings;
    case 'unlinked':
      return summary.unlinked;
    case 'completed':
      return summary.completed;
    case 'all':
      return summary.active + summary.completed;
  }
};

export default function PublicationInboxFolders({
  activeFolder,
  summary,
  onChange,
}: Props) {
  return (
    <nav
      aria-label="Caixas da Inbox Jurídica"
      className="rounded-2xl border border-background-200 bg-background-50 p-2"
    >
      <p className="px-3 pb-2 pt-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-foreground-400">
        Caixas
      </p>

      <div className="space-y-1">
        {publicationInboxFolderMeta.map(
          (folder) => {
            const active =
              activeFolder === folder.value;

            return (
              <button
                key={folder.value}
                type="button"
                onClick={() =>
                  onChange(folder.value)
                }
                className={`flex w-full items-center gap-2 rounded-xl px-3 py-2 text-left text-sm transition ${
                  active
                    ? 'bg-primary-50 font-semibold text-primary-800'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${folder.icon} text-base`}></i>
                <span className="min-w-0 flex-1 truncate">
                  {folder.label}
                </span>
                <span
                  className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${
                    active
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {countForFolder(
                    folder.value,
                    summary
                  )}
                </span>
              </button>
            );
          }
        )}
      </div>
    </nav>
  );
}